"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownToJSON = exports.DropdownFromJSONTyped = exports.DropdownFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function DropdownFromJSON(json) {
    return DropdownFromJSONTyped(json, false);
}
exports.DropdownFromJSON = DropdownFromJSON;
function DropdownFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': !runtime_1.exists(json, '_id') ? undefined : json['_id'],
        'label': _1.DropdownLabelFromJSON(json['label']),
        'values': json['values'],
    };
}
exports.DropdownFromJSONTyped = DropdownFromJSONTyped;
function DropdownToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'label': _1.DropdownLabelToJSON(value.label),
        'values': value.values,
    };
}
exports.DropdownToJSON = DropdownToJSON;
